/*
  ST 2026-07-14: Rollierender Countdown.
  Setzt data-expires ALLER nativen <countdown-timer>-Elemente auf den naechsten
  Rhythmus-Zeitpunkt (Wochentag + Stunde, Europe/Berlin). Das native CountdownTimer
  (theme.js) zaehlt dann von selbst dorthin. Ein Element, ein Mechanismus -> Section-
  Timer UND PDP-Countdown-Block rollieren gleich.

  Konfiguration kommt aus window.stCountdownRolling (snippets/st-countdown-rolling.liquid).
  Rollback: Snippet-Include in theme.liquid entfernen + Setting abschalten. Datei bleibt inert.
*/
(function () {
  var cfg = window.stCountdownRolling;
  if (!cfg || !cfg.enabled) return;

  var TZ = 'Europe/Berlin';
  var targetWeekday = parseInt(cfg.weekday, 10); // 0 = So .. 6 = Sa
  var targetHour = parseInt(cfg.hour, 10);       // 0..23 (Minute = 0)
  if (isNaN(targetWeekday) || isNaN(targetHour)) return;

  // Wall-clock-Teile fuer eine gegebene Instanz in der Ziel-Zeitzone.
  function berlinParts(date) {
    var p = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(date).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
    // 'en-US' liefert Stunde teils als '24' um Mitternacht -> normalisieren.
    var hour = parseInt(p.hour, 10) % 24;
    return {
      year: +p.year, month: +p.month, day: +p.day,
      hour: hour, minute: +p.minute, second: +p.second
    };
  }

  // Offset (ms) der Ziel-Zeitzone fuer eine Instanz -> UTC(wallclock) - realer UTC.
  function tzOffsetMs(date) {
    var b = berlinParts(date);
    var asUTC = Date.UTC(b.year, b.month - 1, b.day, b.hour, b.minute, b.second);
    return asUTC - date.getTime();
  }

  // Naechster Ziel-Zeitpunkt als UTC-ISO-String.
  function nextExpiryISO() {
    var now = new Date();
    var b = berlinParts(now);
    // Wochentag des Berliner Kalendertags (tz-unabhaengig via UTC-Konstruktion).
    var wd = new Date(Date.UTC(b.year, b.month - 1, b.day)).getUTCDay();

    var daysAhead = (targetWeekday - wd + 7) % 7;
    if (daysAhead === 0 && (b.hour > targetHour || (b.hour === targetHour && (b.minute > 0 || b.second > 0)))) {
      daysAhead = 7; // heute schon vorbei -> naechste Woche
    }

    // Ziel-Wall-Clock (Berlin) an Tag+Stunde bauen.
    var target = new Date(Date.UTC(b.year, b.month - 1, b.day + daysAhead, targetHour, 0, 0));
    // Wall-Clock in echte Instanz umrechnen; Offset am Zieltag (DST-sicher).
    var offset = tzOffsetMs(target);
    var instant = target.getTime() - offset;
    // Einmal nachjustieren, falls target ueber eine DST-Grenze rutschte.
    var offset2 = tzOffsetMs(new Date(instant));
    if (offset2 !== offset) instant = target.getTime() - offset2;

    return new Date(instant).toISOString();
  }

  // Zeitpunkt aendert sich nur einmal pro Rhythmus -> einmal berechnen, cachen.
  var cachedISO = null;
  // ST 2026-10-04 (Wrike 4543052992, Ali): the header always counts to this end, also on a PDP with a deal;
  // the PDP deal box and sticky strip take the same end server-side (snippets/st-countdown-end.liquid).
  function apply(root) {
    if (!cachedISO) cachedISO = nextExpiryISO();
    (root || document).querySelectorAll('countdown-timer').forEach(function (el) {
      // Einzeln gesteuerte Timer (eigenes Metafeld-Datum / "fester Termin") NICHT anfassen.
      if (el.getAttribute('data-countdown-fixed') === 'true') return;
      el.setAttribute('data-expires', cachedISO);
      el._date = null; // gemerkte Instanz verwerfen -> Getter liest neu
      if (el.initialized && typeof el.calculate === 'function') el.calculate();
    });
  }

  function boot() {
    apply(document);
    // Dynamisch nachgeladene Timer (Quick-View, Recommendations, Theme-Editor) einfangen.
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            var n = muts[i].addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'COUNTDOWN-TIMER' || (n.querySelector && n.querySelector('countdown-timer'))) {
              apply(n.tagName === 'COUNTDOWN-TIMER' ? n.parentNode : n);
            }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
